import { type Qty, UNITS, type UnitCode } from "@bt/parts-core";

// UNIT_CODES, UNITS and isUnitCode are shared with the collector (@bt/parts-core).

/**
 * Rounds an amount up to what the unit allows: 6.5 of a part counted in pieces is 7, 6.555 L is
 * 6.56 L. Never down, so what a job needs or an order asks for is never short. A removal (negative
 * amount) rounds away from zero the same way: taking out 2.5 pieces takes out 3.
 */
export function roundUpToUnit(qty: Qty, unit: UnitCode): Qty {
  const granularity = 10 ** (3 - UNITS[unit].decimals);
  const rounded = Math.ceil(Math.abs(qty) / granularity) * granularity;
  return qty < 0 ? -rounded : rounded;
}

export function unitStep(unit: UnitCode): Qty {
  return UNITS[unit].step;
}
